// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".our-work-list{padding-bottom:45px;padding-top:45px}.our-work-list .thumbnail{margin-bottom:62px}.our-work-list .thumbnail img{width:100%}@media(min-width:768px){.our-work-list{padding-top:90px}.our-work-list .thumbnail{margin-bottom:85px}.our-work-list__empty{padding-bottom:45px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
